// test976
(976 && 0);
